import { FC, useMemo } from "react";
import {
    Grid,
    GridItem,
    Text,
    Picture,
    useBreakpointValue,
} from "@smile2impress/components/relaunch";
import { withCdnUrl } from "@smile2impress/attraction-utils";

import { ClinicPageArticleProps } from "./ClinicPageArticle.types";
import { ClinicPageArticleContent } from "../ClinicPageArticleContent";

export const ClinicPageArticle: FC<ClinicPageArticleProps> = ({ content }) => {
    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
    });

    const articlePictureComponent = useMemo(
        () => (
            <Picture
                display="flex"
                justifySelf={["auto", "auto", "flex-end"]}
                maxH={["200px", "300px", "none"]}
                w="100%"
                h="100%"
                mb={[2, 2, 0]}
                borderRadius="sm"
                overflow="hidden"
                images={[
                    {
                        jpeg: withCdnUrl(
                            "/images/relaunch/clinicPage/clinic_mobile.jpg"
                        ),
                    },
                    {
                        webp: withCdnUrl(
                            "/images/relaunch/clinicPage/clinic_desktop.webp"
                        ),
                    },
                ]}
                defaultSrc={withCdnUrl(
                    "/images/relaunch/clinicPage/clinic_mobile.jpg"
                )}
            />
        ),
        []
    );

    return (
        <Grid
            gridTemplateColumns={["1fr", "1fr", "repeat(24, 1fr)"]}
            gridColumnGap={["initial", "initial", 2]}
        >
            <GridItem
                colStart={["auto", "auto", 2]}
                colSpan={["auto", "auto", 10]}
            >
                {!!content.title && (
                    <Text textStyle="title1" mb={[3, 3, 2]}>
                        {content.title}
                    </Text>
                )}
                {isMobile && articlePictureComponent}
                <ClinicPageArticleContent content={content.content} />
            </GridItem>
            <GridItem
                colStart={["auto", "auto", 14]}
                colSpan={["auto", "auto", 10]}
            >
                {!isMobile && articlePictureComponent}
            </GridItem>
        </Grid>
    );
};
